module.exports = __webpack_public_path__ + "FixelDisplay-Black-16caa1e6f49123fc362e10cf733ef9a2.woff2";